import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Form, Input } from "antd";
import React from "react";

export const InfoClient = () => {
	return (
		<>
			<Form.List name="clientInformation">
				{(fields, { add, remove }) => {
					return (
						<div className="flex flex-col gap-4">
							<Form.Item className="mb-0">
								<Button
									className="flex items-center justify-center w-[200px] h-[40px] text-[#686868] bg-[#E6E6E6]"
									type="primary"
									onClick={() => add()}
									block
									icon={<PlusOutlined />}
								>
									Nuevo dato de cliente
								</Button>
							</Form.Item>
							{fields.map(({ key, name, ...restField }) => {
								return (
									<div key={key} className="relative">
										<div className="grid grid-cols-1 md:grid-cols-2 gap-2 md:gap-4 mb-4">
											<div className="flex flex-col w-full">
												<p className="mb-2 text-xs font-semibold">Nombre</p>
												<Form.Item className="mb-0" {...restField} name={[name, "name"]}>
													<Input placeholder="Nombre" />
												</Form.Item>
											</div>
											<div className="flex flex-col w-full">
												<p className="mb-2 text-xs font-semibold">* Empresa</p>
												<Form.Item
													className="mb-0"
													{...restField}
													name={[name, "companyName"]}
													rules={[
														{
															required: true,
															message: "Por favor necesita compañia!",
														},
													]}
												>
													<Input placeholder="Empresa" />
												</Form.Item>
											</div>
											<div className="flex flex-col w-full">
												<p className="mb-2 text-xs font-semibold">* Email</p>
												<Form.Item
													className="mb-0"
													{...restField}
													name={[name, "email"]}
													rules={[
														{
															type: "email",
															message: "No es un email!",
														},
														{
															required: true,
															message: "Por favor necesita email!",
														},
													]}
												>
													<Input placeholder="Email" />
												</Form.Item>
											</div>
											<div className="flex flex-col w-full">
												<p className="mb-2 text-xs font-semibold">Rol</p>
												<Form.Item className="mb-0" {...restField} name={[name, "rol"]}>
													<Input placeholder="Rol" />
												</Form.Item>
											</div>
										</div>
										<MinusCircleOutlined className="absolute right-0 top-0" onClick={() => remove(name)} />
									</div>
								);
							})}
						</div>
					);
				}}
			</Form.List>
		</>
	);
};
